var React = require('react');

module.exports = {
  plain: {
    FourOhFour : require('./plain/404'),
    FiveOhThree : require('./plain/503'),
    Maintenance : require('./plain/maintenance')
  },
  sign: {
    FourOhFour : require('./sign/404'),
    FiveOhThree : require('./sign/503'),
    Maintenance : require('./sign/maintenance')
  },
  background: {
    FourOhFour : require('./background/404'),
    FiveOhThree : require('./background/503'),
    Maintenance : require('./background/maintenance')
  }
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/templates/page_type.jsx